(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curated-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.curated-collection');
    if (!section) return;

    var track   = section.querySelector('.curated-collection__track');
    var prevBtn = section.querySelector('.curated-collection__arrow--prev');
    var nextBtn = section.querySelector('.curated-collection__arrow--next');
    var progBar = section.querySelector('.curated-collection__progress-bar');
    if (!track || !prevBtn || !nextBtn) return;

    function getPageWidth() {
      var item = track.querySelector('.curated-collection__item');
      if (!item) return track.offsetWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      if (window.innerWidth < 750) return item.offsetWidth + gap;
      var cols = parseInt(getComputedStyle(section).getPropertyValue('--cc-cols').trim()) || 4;
      return (item.offsetWidth + gap) * cols;
    }

    function updateUI() {
      var max = track.scrollWidth - track.offsetWidth;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= max - 2;
      if (progBar) {
        progBar.style.width = max > 0 ? ((track.scrollLeft / max) * 100) + '%' : '100%';
      }
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getPageWidth(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getPageWidth(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateUI, { passive: true });
    updateUI();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shoppable-video').forEach(function (section) {
    var track = section.querySelector('.shoppable-video__cards');
    var progressBars = section.querySelectorAll('.sv-progress');

    function updateProgress() {
      if (!track) return;
      var allCards = Array.from(track.querySelectorAll('.shoppable-video__card'));
      var scrollLeft = track.scrollLeft;
      var closestIdx = -1;
      var closestDist = Infinity;
      allCards.forEach(function (card, i) {
        if (card.style.display === 'none') return;
        var dist = Math.abs(card.offsetLeft - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = i;
        }
      });
      progressBars.forEach(function (bar) {
        bar.querySelectorAll('.sv-progress__seg').forEach(function (seg, i) {
          seg.classList.toggle('sv-progress__seg--active', i === closestIdx);
        });
      });
    }

    if (track && progressBars.length) {
      track.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    }

    section.querySelectorAll('.shoppable-video__dismiss').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.shoppable-video__card');
        if (!card) return;
        var allCards = Array.from(track.querySelectorAll('.shoppable-video__card'));
        var cardIdx = allCards.indexOf(card);
        card.style.transition = 'opacity 0.3s, transform 0.3s';
        card.style.opacity    = '0';
        card.style.transform  = 'translateY(8px)';
        if (cardIdx !== -1) {
          progressBars.forEach(function (bar) {
            var segs = bar.querySelectorAll('.sv-progress__seg');
            if (segs[cardIdx]) {
              segs[cardIdx].style.transition = 'opacity 0.3s';
              segs[cardIdx].style.opacity = '0';
              setTimeout(function () { segs[cardIdx].style.display = 'none'; }, 320);
            }
          });
        }
        setTimeout(function () {
          card.style.display = 'none';
          updateProgress();
        }, 320);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
